import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddVisitor from "./pages/AddVisitor";
import Scan from "./pages/Scan";
import Register from "./pages/Register";
import VisitorPortal from "./pages/VisitorPortal";
import VisitorPass from "./pages/VisitorPass";
import PassLookup from "./pages/PassLookup";


const PrivateRoute = ({children, allowedRoles}) =>{
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if(!token){
    if(allowedRoles && allowedRoles.includes("visitor")){
      return <Navigate to="/visitor" />;
    }

    return <Navigate to="/" />;
  }

  if(allowedRoles && !allowedRoles.includes(role)){
    if(role === "visitor"){
      return <Navigate to="/visitor/pass" />;
    }
    return <Navigate to="/dashboard" />;
  }

  return children;
};

function App(){
  return(
    <BrowserRouter>
      <Routes>
        {/* --- PUBLIC ROUTES --- */}
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/visitor" element={<VisitorPortal />} />

        {/* --- PROTECTED ROUTES*/}
        <Route path="/dashboard" 
          element={
            <PrivateRoute allowedRoles={["admin", "employee", "security"]}>
              <Dashboard />
            </PrivateRoute>
          } 
        />
        
        <Route path="/add" 
          element={
            <PrivateRoute allowedRoles={["admin", "employee"]}>
              <AddVisitor />
            </PrivateRoute>
          } 
        />

        <Route path="/scan" 
          element={
            <PrivateRoute allowedRoles={["admin", "security"]}>
              <Scan />
            </PrivateRoute>
          } 
        />

        <Route
          path="/pass-lookup"
          element={
            <PrivateRoute allowedRoles={["admin", "employee", "security"]}>
              <PassLookup />
            </PrivateRoute>
          }
        />

        <Route path="/visitor/pass"
          element={
            <PrivateRoute allowedRoles={["visitor"]}>
              <VisitorPass />
            </PrivateRoute>
          }
        />

        {/*for wrong url*/}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
